const address = {
  ADDRESS_API_STARTED: "ADDRESS_API_STARTED",
  ADDRESS_MODAL_API_STARTED: "ADDRESS_MODAL_API_STARTED",
  ADDRESS_OPERATION_FAILED: "ADDRESS_OPERATION_FAILED",

  ADDRESS_SUGGESTED: "ADDRESS_SUGGESTED",
  ADDRESS_VALIDATED: "ADDRESS_VALIDATED",

  ADDRESS_COUNTRY_STATE_FETCHED: "ADDRESS_COUNTRY_STATE_FETCHED",
  // ADDRESS_COUNTRY_STATE_FAILED: 'ADDRESS_COUNTRY_STATE_FAILED',

  ADDRESS_CHANGE_SELECTED: "ADDRESS_CHANGE_SELECTED",
  ADDRESS_CLEAR_SUGGESTED: "ADDRESS_CLEAR_SUGGESTED",
  ADDRESS_EDIT_SET: "ADDRESS_EDIT_SET",
  ADDRESS_DELETE_SET: "ADDRESS_SET_DELETION",

  ADDRESS_SAVED_FETCHED: "ADDRESS_SAVED_FETCHED",
  ADDRESS_UPDATE_SUCCESS: "ADDRESS_UPDATE_SUCCESS",
  ADDRESS_FIRST_TIME: "ADDRESS_FIRST_TIME",
  ADDRESS_FORM_SET_MODE: "ADDRESS_FORM_SET_MODE",
  ADDRESS_FETCH_API_STARTED: "ADDRESS_FETCH_API_STARTED",

  // Address Form Modes
  ADDRESS_FORM_MODE_ADD: "ADDRESS_FORM_MODE_ADD",
  ADDRESS_FORM_MODE_EDIT: "ADDRESS_FORM_MODE_EDIT",
  ADDRESS_DISPLAY_ERROR_PROCEED_PAYMENT:
    "ADDRESS_DISPLAY_ERROR_PROCEED_PAYMENT",
  ADDRESS_PREDICTION_FETCH: "ADDRESS_PREDICTION_FETCH",
  ADDRESS_SET_INPUT_VALUE: "ADDRESS_SET_INPUT_VALUE",
  ADDRESS_FETCH_FORMATTED_ADDRESS_SUCCESS:
    "ADDRESS_FETCH_FORMATTED_ADDRESS_SUCCESS",
  ADDRESS_FETCH_FORMATTED_ADDRESS_FAILURE:
    "ADDRESS_FETCH_FORMATTED_ADDRESS_FAILURE",
  ADDRESS_TOGGLE_KEY_DOWN_FOCUS: "ADDRESS_TOGGLE_KEY_DOWN_FOCUS",
  ADDRESS_CLEAR_FORMATTED_ADDRESS: "ADDRESS_CLEAR_FORMATTED_ADDRESS",
  ADDRESS_FETCH_STARTED: "ADDRESS_FETCH_STARTED",
}

export default address
